import { Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import SectionHeader from '../../../../common/layouts/header/sectionHeader';
import { rootSelector } from '../../../../common/selectors/selectors';
import { CenteredText, TopMarginGrid } from '../../../../common/styles/styles';
import { exhibitsActions } from '../../../exhibits/exhibits.actions';
import { ExhibitDto } from '../../../exhibits/exhibits.dtos';
import { groupVisitActions } from '../../groupVisits.actions';
import { GroupVisitDto, groupVisitInit } from '../../groupVisits.dtos';
import ExhibitList from './exhibits/exhibitList';
import GroupVisitHeader from './headers/groupVisitHeader';
import ImageList from './images/imageList';

interface DetailParams {
  id: string;
}

const GroupVisitSummary: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
}) => {
  const dispatch = useDispatch();

  const systemGroupVisit = rootSelector(
    (state) => state.groupVisits.groupVisit
  );

  const [exhibits, setExhibits] = useState<ExhibitDto[]>([]);
  const [groupVisit, setGroupVisit] =
    React.useState<GroupVisitDto>(groupVisitInit);

  useEffect(() => {
    dispatch({
      type: getType(groupVisitActions.request),
      payload: match.params.id,
    });
  }, [match.params.id, dispatch]);

  useEffect(() => {
    setGroupVisit(systemGroupVisit);
  }, [systemGroupVisit, dispatch, match.params.id]);

  return (
    <>
      <GroupVisitHeader title='Group Visit Portal' />
      <TopMarginGrid
        container
        alignItems='center'
        justify='center'
        direction='column'
      >
        <Grid item>
          <CenteredText>
            Thank you for enjoying a visit with your group at the Sloan Museum.
            Below is a summary of the Exhibits visited, and memories captued.
            This page will be available until{' '}
            <span style={{ fontWeight: 'bold' }}>
              {moment(groupVisit.expirationDate).format('MM/DD/YYYY')}
            </span>
            . You will be able to download images and video below. If you have
            any questions, please contact our reservations team.
          </CenteredText>
          <CenteredText>
            810-237-3409 |{' '}
            <span>
              <a href='mailto:Reservations@SloanLongway.org'>
                Reservations@SloanLongway.org
              </a>
            </span>{' '}
          </CenteredText>
        </Grid>
        <SectionHeader title='Exhibits' />
        {groupVisit.scans != null ? (
          <ExhibitList exhibits={groupVisit.scans} />
        ) : (
          <Typography>No exhibits were scanned.</Typography>
        )}
        <SectionHeader title='Memories' />
        {groupVisit.images != null && groupVisit.images.length > 0 ? (
          <ImageList images={groupVisit.images} />
        ) : (
          <Typography>No photos or videos were taken.</Typography>
        )}
      </TopMarginGrid>
    </>
  );
};

export default GroupVisitSummary;
